module.exports = {
  BEST_PRACTICE: "Best Practice",
  SEO: "SEO",
  ACCESSIBILITY: "Accessibility",
  STYLE: "Style",
};
